import { render, staticRenderFns } from "./achievement-analysis.vue?vue&type=template&id=5153fb6a&scoped=true"
import script from "./achievement-analysis.vue?vue&type=script&lang=js"
export * from "./achievement-analysis.vue?vue&type=script&lang=js"
import style0 from "./achievement-analysis.vue?vue&type=style&index=0&id=5153fb6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153fb6a",
  null
  
)

export default component.exports